<template>
  <v-menu
    v-if="usuario"
    offset-y
    origin="right top"
    left
    content-class="language-dropdown"
    transition="slide-y-transition"
    nudge-top="-10"
    class="user-block-wrap"
  >
    <v-btn
      icon
      large
      slot="activator"
    >
      <img
        src="/static/img/user-profile.png"
        class="user-profile"
      />
    </v-btn>
    <div class="dropdown-content">
      <div class="dropdown-top secondary">
        <span class="fs-14 fw-bold d-block center--text white--text">{{ nombreCompleto }}</span>
        <span class="d-block fs-12 fw-normal white--text">{{ usuario.email }}</span>
      </div>
      <v-list class="dropdown-list dark">
        <v-list-tile
          @click="miPerfil"
          v-if="$puedo('gral_perfil:lectura')"
        >
          <v-icon small>person</v-icon>
          <span>Mi perfil</span>
        </v-list-tile>
        <v-list-tile @click="salir">
          <v-icon small>exit_to_app</v-icon>
          <span>Salir</span>
        </v-list-tile>
      </v-list>
    </div>
  </v-menu>
</template>
<script>

export default {

  computed: {
    usuario () {
      return this.$store.getters.getUser
    },
    nombreCompleto () {
      return this.usuario.persona.apellido + ', ' + this.usuario.persona.nombre
    }
  },
  methods: {
    salir () {
      this.$store.dispatch('logout', this.$router)
    },
    miPerfil () {
      this.$router.push({ name: 'mi-perfil' })
    }
  }
}
</script>
<style scoped>
.user-profile {
  max-width: 47px;
}
span:hover {
  color: #604492 !important;
}
</style>
